export const PHONE_NUMBER = '8 (029) 665-99-65';
export const PHONE_NUM_CALL = '+375296659965';
export const EMAIL = 'info@tourhunter.by';

export const HOME_PAGE = 'HOME_PAGE';
export const TOUR_SEARCH_RESULT = 'TOUR_SEARCH_RESULT';
export const HOTEL_DETAILS = 'HOTEL_DETAILS';
export const NOT_AVAILABLE = 'Временно недоступно';
export const TURKEY_COUNTRY_ID = 119;

// Order statuses
export const ORDER_WAIT_PAYMENT_STATUS = 'WAIT_PAYMENT';
export const ORDER_WAIT_APPROVAL_STATUS = 'WAIT_APPROVAL';
export const ORDER_APPROVED_STATUS = 'APPROVED';
export const ORDER_DECLINED_STATUS = 'DECLINED';

export const ORDER_WAIT_PAIMENT = 'Ожидает оплаты';
export const ORDER_WAIT_APPROVAL = 'Ожидает подтверждения';
export const ORDER_APPROVED = 'Подтвержден';
export const ORDER_DECLINED = 'Отклонен';

// profile order card
export const PROFILE_ORDER_NUMBER = 'Заказ №';
export const PROFILE_ORDER_DEPARTURE = 'Вылет';
export const PROFILE_ORDER_DEPARTURE_CITY = 'Город вылета';
export const PROFILE_ORDER_TOURISTS = 'Туристы';
export const PROFILE_ORDER_ROOM = 'Номер';
export const PROFILE_ORDER_MEAL = 'Питание';
export const PROFILE_ORDER_PRICE = 'Стоимость';
export const PROFILE_ORDER_TOUR = 'Тур';
export const PROFILE_ORDER_NIGHTS = 'Ночей';
export const PROFILE_ORDER_OPERATOR = 'Туроператор';
export const PROFILE_ORDER_PROGRAM = 'Программа';
export const PROFILE_ORDER_PLACEMENT = 'Размещение';
export const PROFILE_ORDER_FLIGHT_TO = 'Туда';
export const PROFILE_ORDER_FLIGHT_BACK = 'Обратно';
export const PROFILE_ORDER_TOTAL = 'Итого';
export const PROFILE_ORDER_OPERATOR_PRICE = 'Цена туроператора';
export const PROFILE_ORDER_INSURANCE = 'Страховка от невылета';
export const PROFILE_ORDER_PROMO = 'Промокод';
export const PROFILE_ORDER_PREPAYMENT = 'Предоплата';
export const PROFILE_ORDER_FULL_NAME = 'ФИО';
export const PROFILE_ORDER_BIRTH_DAY = 'Дата рождения';
export const PROFILE_ORDER_LAST_NAME_LAT = 'Фамилия латиницей';
export const PROFILE_ORDER_FIRST_NAME_LAT = 'Имя латиницей';
export const PROFILE_ORDER_TOURIST = 'Турист';
export const TOURIST_CHILD = 'ребенок';
// buyer and tourists data for an order created by a manager
export const PROFILE_PEOPLE_MISSING = 'Нужно заполнить данные туристов';
export const PROFILE_PEOPLE_TITLE = 'Заполните данные для договора';
export const PROFILE_PEOPLE_TEXT =
  'Менеджер оформил для вас заказ. Чтобы заключить договор, укажите данные заказчика и всех туристов так, как в паспорте.';
export const PROFILE_PEOPLE_FILL = 'Заполнить';
export const PROFILE_PEOPLE_SAVE = 'Сохранить данные';
export const PROFILE_PEOPLE_EDIT = 'Изменить';
export const PROFILE_PEOPLE_CANCEL = 'Отмена';
export const PROFILE_PEOPLE_SAVE_ERROR =
  'Не удалось сохранить данные. Попробуйте еще раз или свяжитесь с менеджером';
export const PROFILE_ORDER_YES = 'Да';
export const PERSON_PASSPORT = 'Паспорт';
export const PERSON_BUYER = 'Заказчик';
export const ARRIVAL_NEXT_DAY = 'Прилёт на следующий день по местному времени';
export const ARRIVAL_IN = 'Прилёт через';
export const ARRIVAL_LOCAL_TIME = 'по местному времени';
export const ORDER_WAIT_PAYMENT_HINT = 'Оплата заказа не завершена';
export const ORDER_WAIT_APPROVAL_HINT =
  'Менеджер бронирует тур у туроператора, мы сообщим о подтверждении';
export const ORDER_APPROVED_HINT = 'Туроператор подтвердил бронирование';
export const ORDER_DECLINED_HINT =
  'Туроператор не подтвердил бронирование, менеджер свяжется с вами';

// login modal
export const LOGIN_TITLE = 'Вход в личный кабинет';
export const EMAIL_ADDRESS_LABEL = 'Адрес электронной почты';
export const PASSWORD_LABEL = 'Придумайте пароль';
export const ENTER = 'Войти';
export const SAVE = 'Сохранить';
export const NO_ACCOUNT = 'Еще нет аккаунта?';
export const HAVE_ACCOUNT = 'У вас уже есть аккаунт?';
export const ALREADY_REGISTERED =
  'Пользователь с этим email уже зарегистрирован';
export const START_REG = 'Зарегистрироваться';
export const REGISTER = 'Регистрация';
export const INITIATE_REGISTER = 'Зарегистрироваться';
export const REGISTER_SUCCESS = 'Регистрация прошла успешно';
export const REGISTER_SUCCESS_TEXT =
  'Мы отправили письмо для подтверждения на';
export const CONTINUE = 'Продолжить';
// Errors
export const INCORRECT_EMAIL_FORMAT = 'Неверный формат электронной почты';
export const BAD_CREDENTIALS = 'Неверный пароль или адрес электронной почты';

export const SUCCESS_STATUS = 'SUCCESS';
export const ERROR_STATUS = 'ERROR';

export const SUCCESS_TEXT = 'Успешно';
export const ERROR_TEXT = 'Ошибка';

export const EGYPT_NAME = 'Египет';
export const GEORGIA_NAME = 'Грузия';
export const UAE_NAME = 'ОАЭ';
export const TURKEY_NAME = 'Турция';
export const CHINA_NAME = 'Китай';
export const QATAR_NAME = 'Катар';
export const OMAN_NAME = 'Оман';
export const RUSSIA_NAME = 'Россия';
export const THAILAND_NAME = 'Таиланд';

export const HOTEL_NAME = 'Название отеля';

export const HOTEL_CLASS = 'Класс отеля';
export const MEAL = 'Питание';
export const ANY = 'Любое';
export const RATING = 'Рейтинг';
export const RATING_3_5_PLUS = '3.5+';
export const RATING_4_PLUS = '4+';
export const RATING_4_5_PLUS = '4.5+';
export const BEACH_LINE = 'Пляжная линия';
export const RESORT = 'Курорт';
export const BUDGET = 'Бюджет';
export const BEACH_TYPE = 'Тип пляжа';
export const OPERATOR = 'Оператор';
export const HOTEL_TYPE = 'Тип отеля';
export const FIRST = 'Первая';
export const VERY_GOOD = 'Очень хорошо';
export const GOOD = 'Хорошо';
export const PERFECT = 'Превосходно';
export const CHARTER_ONLY = 'Только чартер';
export const DIRECT_FLIGHT = 'Прямой';
export const DIRECT_FLIGHT_FULL = 'Прямой перелёт';
export const AVAILABLE_DATES_HINT = 'Есть вылеты в эти даты';
export const FLIGHT = 'Рейс';
export const SHOW_MORE = 'Показать еще';

export const ALL = 'Все';
export const SELECTED = 'Выбрано';
export const CLEAR_FILTERS = 'Сбросить фильтры';
export const SHOW = 'Показать';

export const CURRENCY = 'валюта';
export const FILTERS = 'Фильтры';
export const SHOW_ON_MAP = 'Посмотреть на карте';
export const HIDE_MAP = 'Скрыть карту';
export const EXPAND_MAP = 'Развернуть карту';
export const SEA_DIST = 'до моря';
export const SEARC_PRICES = 'Ищем лучшие цены...';

// Hotel Description
export const ABOUT_HOTEL = 'Об отеле';
export const HOTEL_MAP = 'Карта';
export const COMMON_INFO = 'Общие';
export const HOTEL_DESC = 'Описание отеля';
export const BUILD = 'Год строительства';
export const REPAIR = 'Реставрация';
export const DESCRIPTION = 'Описание';
export const PLACEMENT = 'Расположение';
export const TERRITORY = 'Территория';
export const IN_ROOM = 'В номере';
export const ROOM_TYPES = 'Типы номеров';
export const SQUARE_METERS = 'м²';
export const ROOM_WORDS = ['комната', 'комнаты', 'комнат'];
export const BEDROOM_WORDS = ['спальня', 'спальни', 'спален'];
export const SLEEPING_PLACES = 'Спальные места';
export const ROOM_VIEW = 'Вид';
export const ROOM_COMMENT = 'Примечание';
export const ROOM_BALCONY = 'Балкон';
export const ROOM_KITCHEN = 'Кухня';
export const SERVICES = 'Услуги';
export const SERVICES_FREE = 'Бесплатные услуги';
export const SERVICES_PAY = 'Платные услуги';
export const ANIMATION = 'Развлечения';
export const CHILD = 'Для детей';
export const BEACH = 'Описание пляжа';
export const MEAL_LIST = 'Питание';
export const MEAL_TYPES = 'Концепция питания';
export const REVIEWS = 'Отзывы';
export const COMMON_RATE = 'Общая оценка';
export const MORE_DET = 'Подробнее';
export const PLUS = 'Плюсы';
export const MINUS = 'Минусы';
export const READ_MORE = 'Показать полностью';
export const TOURS_NOT_FOUND = 'По данному запросу туров не найдено';
export const SYSTEM_FAULT = 'Произошла ошибка. Попробуйте еще раз.';
export const PROGRAMM = 'Программа';
export const ROOM_TYPE = 'Тип номера';
export const TOUR_INCLUDED = 'В состав тура входит';
export const TOUR_INC_AVIA = 'Авиаперелет';
export const TOUR_INC_HOTEL = 'Проживание';
export const TOUR_INC_MED = 'Медстраховка';
export const TOUR_INC_TRANSFER = 'Трансфер';
export const DIRECT = 'Прямой';
export const TRANSFER = 'Пересадка';
export const CHOOSE_ANOTHER = 'Выбрать другой перелет';

export const FOR_PAY = 'К оплате';
export const YOUR_EMAIL = 'Ваш email*';
export const CALL_BACK_PHONE = 'Ваш телефон*';
export const BOOK = 'Перейти к бронированию';
export const TOUR_PRICE = 'Цена тура';
export const FUEL_CHARGE = 'Топливный сбор';
export const I_HAVE_PROMOCODE = 'У меня есть промокод';
export const ENTER_PROMO = 'Введите промокод...';
export const ADD_NOTE = 'Добавить примечание';
export const YOUR_NOTE = 'Ваше примечание...';
export const APPLY = 'Применить';
export const PROMO_CODE_ERROR = 'Промокод не найден';
export const PROMO_CODE_COUNTRY_ERROR =
  'Невозможно применить промокод для этого города вылета';
export const FLIGHT_INSURANCE = 'Страховка от невылета';
export const INSUTANCE_MANAGER = 'Менеджер сообщит точную стоимость';
export const INSURANCE_BEFORE_DAYS =
  'Страховка от невылета доступна не позднее чем за';
export const BEFORE_FLIGHT = 'до вылета';
export const SPLIT_PRICE = 'Первоначальный взнос';
export const PAY_NOW = 'Сумма к оплате сейчас';
export const PAY_REST = 'Оставшаяся сумма';
export const BOOKING_NOT_AVAILABLE = 'Бронирование временно недоступно.';
export const TOUR_DATA_OUTDATED = 'Информация о туре устарела.';
export const DISCOUNT = 'Скидка';
export const WE_ON_CALL = 'Мы на связи в любом из мессенджеров';
export const TELEGRAM = 'Telegram';
export const VIBER = 'Viber';
export const INSTAGRAM = 'Instagram';
export const CONTACT_US = 'Написать нам';

export const ONLIBE_BOOK_NOT_AVAIL =
  'Этот тур пока недоступен для онлайн-бронирования';
export const CONTACT_US1 = 'Напишите нам';
export const AND_WE_CHECK = 'и мы уточним детали и поможем с оформлением';

export const USER_PROFILE = 'Личный кабинет';
export const EXIT = 'Выйти';

export const HELP_MODAL_TITLE = 'Не можете определиться с отелем?';
export const I_AM_NATALLI =
  'Меня зовут Наталья, и я с радостью помогу вам сделать правильный выбор';
export const OR = 'или';
export const CALL = 'Позвоните';
export const COOCKIE_TITLE =
  'Мы используем cookie, чтобы сделать сайт удобнее';
export const COOCKIE_DESC =
  'Мы используем cookie, чтобы сделать работу сайта удобнее и предлагать лучшие туры. Продолжая пользоваться сайтом, вы соглашаетесь с их использованием.';
export const ACCEPT_COOCKIE = 'Принять все cookie';
export const DECLINE = 'Отклонить';
export const HOTEL_SERACH = 'Поиск отеля';

export const BYN_TEXT = 'BYN';
export const USD_TEXT = 'USD';
export const EUR_TEXT = 'EUR';
export const RUB_TEXT = 'RUB';

export const MAIN_PAGE = 'Главная';
export const SLASH_DELIMITER = '/';
export const OTHER_PHOTO = 'Другие фото';
export const PLACES_AVAILABILTY = 'Наличие мест на';
export const FOR = 'для';
export const ALL_MEAL_TYPES = 'Все типы питания';
export const NIGHT = 'ночь';
export const GUEST_REVIEWS = 'Отзывы гостей';
export const TOUR_IN = 'Тур в';
export const TOUR_DETAILS = 'Детали тура';
export const PAYMENT = 'Оплата';
export const CONTACT_INFO = 'Контактные данные';
export const TOTAL = 'Итого';
export const TO = 'Туда';
export const BACK = 'Обратно';
export const FLIGHT_DETAILS = 'Детали перелета';
export const IN_TRIP = 'В пути';
export const BOOK_TOUR = 'Забронировать тур';
export const FLIGHT_INFO =
  'Информацию о рейсах можно уточнить у менеджеров нашей компании';
export const SELECT_FLIGHT = 'Выберите перелет';
export const SLECT = 'Выбрать';
export const FLIGHT_TO_INFO = 'Информация о рейсе туда';
export const FLIGHT_FROM_INFO = 'Информация о рейсе обратно';
export const CHEAPEST = 'Самый дешевый';
export const TOUR_PAYMENT = 'Оплата тура';
export const WE_ON_CALL_SHORT = 'Мы на связи';
export const CONTACT_TEXT =
  'Выбирайте туры с нами каждый день с 9 до 20, а во время поездки обеспечиваем круглосуточную поддержку 24/7';
export const COMPANY_INFO = 'Данные компании';
export const COMPANY_NAME = 'Название компании';
export const IP = 'Индивидуальный предприниматель';
export const ADDRESS = 'Юридический и почтовый адрес';
export const REGISTRY_CERTIFICATE = 'Свидетельство о регистрации';
export const PHONE_TEXT = 'Телефон';
export const EMAIL_TEXT = 'E-mail';
export const WORK_HOURS = 'Режим работы';
export const ABOUT_TOURHUNTER = 'О компании TourHunter';
export const WHY_TORHUNTER = 'Почему TourHunter?';
export const HOW_TO_BUY = 'Как купить тур?';
export const KEY_FACES = 'Ключевые лица';
export const OUR_TEAM = 'Наша команда';
export const CONSULT_HOURS = 'Пн-Вс: с 9:00 до 20:00';
export const CONSULT_HOURS_DESC = `${CONSULT_HOURS} - помощь в подборе тура`;
export const SUPPORT_HOURS = '24/7 - поддержка действующих клиентов';
export const PROFILE = 'Аккаунт';
export const MY_ACCOUNT = 'Мой аккаунт';
export const MY_ORDERS = 'Мои заказы';
export const PERSONAL_ONFO = 'Личная информация';
export const PERSONAL_TAB = 'personal';
export const ORDERS_TAB = 'order';
export const NO_ORDERS_YET = 'Вы еще не сделали ни одного заказа.';
export const PLAN_TRIP = 'Спланируйте свое приключение вместе с нами!';
export const PDOBRAT_TOUR = 'Подобрать тур';
export const SEARCH_MORE = 'Найти больше туров';

// hot
export const HOT_TOURS = 'ГОРЯЩИЕ ТУРЫ';
export const HOT_TELEG = 'Будь в курсе актуальных горящих туров';
export const SUBSCRIBE = 'Подписаться на канал';
export const HOT_FROM = 'Откуда';
export const HOT_COUNTRY = 'Страна';
export const HOT_PERIOD = 'В период';
export const HOT_SEARCH_TOUR = 'Искать тур';
export const HOT_5_STAR = 'Отличные 5*';
export const HOT_AI = 'Все включено +';
export const HOT_USD = 'USD';
export const TWO_ADULTS = '2 взрослых';
export const HOT_FLIGHT = 'Перелет';
export const HOT_FLIGHT_ANY = 'Любой';
export const HOT_FLIGHT_CHARTER = 'Чартер';
export const HOT_PERIOD_3D = '3 дня';
export const HOT_PERIOD_1W = 'Неделя';
export const HOT_PERIOD_1M = 'Месяц';
export const HOT_PERIOD_ANY = 'Любой';
export const HOT_FROM_TITLE = 'Горящие туры из';
